function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.356 5.381c0-.356.291-.622.641-.622.356 0 .647.266.647.622a.63.63 0 01-.647.625.628.628 0 01-.64-.625zM7.4 6.797a.3.3 0 01.3-.3h.594a.3.3 0 01.3.3V10.7a.3.3 0 01-.3.3H7.7a.3.3 0 01-.3-.3V6.797z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 2.375c1.503 0 2.916.584 3.978 1.647A5.588 5.588 0 0113.625 8a5.588 5.588 0 01-1.647 3.978A5.588 5.588 0 018 13.625a5.588 5.588 0 01-3.978-1.647A5.588 5.588 0 012.375 8c0-1.503.584-2.916 1.647-3.978A5.588 5.588 0 018 2.375zM8 1.5C4.41 1.5 1.5 4.41 1.5 8s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5z"
});

function SvgInformationWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgInformationWhiteIcon;